import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {BehaviorSubject} from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
    providedIn: 'root'
})

export class RmRateService {
    private rates: any;

    constructor(protected http: HttpClient, private auth: AuthService) {
        this.rates = new BehaviorSubject<any>(null);
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getRatesFromService() {
        return this.http.get(environment.rmEndpoint + 'master/rates', {headers: this.getHeaders()});
    }

    setRates(data) {
        this.rates.next(data);
    }

    getRates() {
        return this.rates.asObservable();
    }
}
